var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-button',_vm._b({attrs:{"type":"submit","data-test":"blain-form-submit"}},'ui-button',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Submit")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }